import React, { useState } from 'react';
import axios from 'axios';
import './Signin.css'; // External CSS file for styling

const Signin = () => {
  // const [userId, setUserId] = useState('');
  // const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // Loading state to handle form submission

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true); // Set loading state to true when the form is submitted
    setError(''); // Reset any previous error messages
    // console.log("xxxxxxxxxxxxxxxxxx")
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/signin`, {
        email,
        password,
      });
      //   console.log(response)
      // If login is successful, store JWT token in localStorage
      if (response.data.token) {
        localStorage.setItem('calendar_admin', response.data.token); // Store token
        localStorage.setItem('admin_user', response.data.admin); // Store token
        localStorage.setItem('admin_lvl', response.data.lvl); // Store token
        localStorage.setItem('userId', response.data.userId); // Store userId
        localStorage.setItem('username', response.data.username); // Store username

        // Redirect the user to a protected route (e.g., dashboard)
        if (response.data.admin === true) {
          window.location.href = '/admin'; // Redirect after successful login
        }
        else {
          window.location.href = '/'; // Redirect after successful login
        }
      }
    } catch (err) {
      // Handle any error returned by the server
      // if (err.response) {
        if (err.response.status == 400 ) {
          setError('Mail is already exist');
        } else {
          setError(err.response.data|| 'An error occurred');
        }

      // }
    } finally {
      setLoading(false); // Set loading state back to false after request is complete
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-form">
        <h2>Sign In</h2>
        {error && <p className="error-message">{error}</p>} {/* Display error message */}
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
            />
          </div>
          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />
          </div>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'} {/* Show loading indicator when form is submitted */}
          </button>
        </form>
        <p className="signup-link">
          Don't have an account? <a href="/signup">Sign Up</a>
        </p>
      </div>
    </div>
  );
};

export default Signin;
